import { isPresent } from '@mode/shared/util-js';
import { createSelector } from 'reselect';
/*
Contains legacy store selector paths
TODO: Will contain NgRx selectors once we migrate legacy notebook state to NgRx state
Based on selectors in notebook.selectors.ts
*/

const notebookPath = (state: any) => state?.client?.notebooks;

const cellPath = (state: any) => notebookPath(state)?.cells;

export const getQueries = (state: any) => state?.client?.selectedReport?.queries;

export const notebookToken = (state: any) => notebookPath(state)?.books?.tokens?.first();

export const notebookTypesArray = (state: any) => notebookPath(state)?.books?.notebookTypes;

export const notebookSession = (state: any) => notebookPath(state)?.books?.sessions?.get(notebookToken(state));

export const notebookState = (state: any) => notebookPath(state)?.books?.resources;

export const selectedNotebookType = createSelector(notebookToken, notebookTypesArray, (notebookToken, types) =>
  types?.get(notebookToken)
);

export const notebookCellState = (state: any) => cellPath(state);

export const selectedCellToken = (state: any) => notebookPath(state)?.editor?.selectedCellToken;

export const cellContentTypesArray = (state: any) => cellPath(state)?.contentTypes;

export const cellContentResourcesArray = (state: any) => cellPath(state)?.resources;

export const selectedCellContentType = createSelector(
  selectedCellToken,
  cellContentTypesArray,
  (cellToken, cellContentsArray) => cellContentsArray?.get(cellToken)
);

export const selectedCellIsExported = createSelector(
  selectedCellToken,
  cellContentResourcesArray,
  (cellToken, cellResourcesArray) => {
    const cellResource = cellResourcesArray?.get(cellToken);
    return isPresent(cellResource?.local_dataset_exported_at);
  }
);
